module.exports = __webpack_public_path__ + "static/monei_pay_4_en-e8a6a30a05ac740b24f555fed1fa6ffe.png";